const ManageLeaderboardSection: React.FC = () => {
  return (
    <>
      <p>Manage Leaderboard coming soon..</p>
    </>
  );
};
export default ManageLeaderboardSection;
